import * as yup from 'yup'
export const AddCardSchema = yup.object().shape({
    storename: yup.string().max(15).required('store name is a required field'),
    cardnum: yup.string().min(4).required('card number is a required field'),
    notes: yup.string().max(300)

})